import appStyles from "./App.module.css";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  datePickerFormat: "dd/MM/y",
  EMAIL_REGEX: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
};
// if environment is staging or production then we get url form wordpress
export const _window: any = window;

export const baseFolderUrl = _window?.BFPlugin?.webappBaseUrl || "";
export const docFolderUrl = process.env.REACT_APP_ENV !== "development" ? `${baseFolderUrl}/build` : baseFolderUrl;

// date in api format
export const convertDateToApiFormat = (date: Date | null) =>
  date
    ? `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`
    : "";

// calculate Leap year
export const totalDaysInCurrentYear = (startDate: Date | null): number => {
  const _currentYear: any = startDate && new Date(startDate?.toString()).getFullYear();
  const _currentMonth: any = startDate && new Date(startDate.toString()).getMonth();
  return (startDate && _currentYear % 4 === 0 && _currentYear % 100 !== 0 && _currentMonth <= 1) ||
    (_currentYear % 400 === 0 && _currentMonth <= 1)
    ? 365
    : 364;
};

// format date so that display in Specific format
export const formatDate = (_date: Date | null, formatType?: string) => {
  const date = new Date(_date!);

  return date
    ? date?.toLocaleDateString("en-US", {
        year: "numeric",
        month: formatType === "short" ? "short" : "long",
        day: "numeric",
      })
    : "";
};

// format amount with currency and country according
export const formatAmount = (
  amount: number,
  country: string,
  currency: string,
  minFractionDigit: number = 2,
  maxFractionDigits: number = 2
) =>
  new Intl.NumberFormat(`en-${country}`, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: minFractionDigit,
    maximumFractionDigits: maxFractionDigits,
    currencyDisplay: "narrowSymbol",
  }).format(amount);

// add days in particular date
export const addDays = (dateInput: Date, count: number): Date => {
  let _date: Date = new Date(dateInput);
  let increasedDate = new Date(_date.getTime() + count * 86400000);
  increasedDate.setHours(0, 0, 0, 0);
  return increasedDate;
};

export const subtractYears = (dateInput: Date, count: number): Date => {
  let _date = new Date(dateInput);
  _date.setFullYear(_date.getFullYear() - count);

  return _date;
};

export const isValidDate = (date: any) => {
  return convertDateToApiFormat(date).length === 10;
};
export const selectControlStyling = (state: any) => {
  const classes = [appStyles.bfFormControl];
  if (state.isFocused) {
    classes.push(appStyles.bfFormControlFocused);
  }
  return classes.join(" ");
};

export const selectOptionControlStyling = (state: any) => {
  const classes = [appStyles.bfFormControl];
  if (state.isSelected) {
    classes.push(appStyles.bfFormControlOptionSelected);
  }
  if (state.isFocused) {
    classes.push(appStyles.bfFormControlOptionFocused);
  }
  return classes.join(" ");
};
